import { render, staticRenderFns } from "./DetailBarangKeluar.vue?vue&type=template&id=57b222a0"
import script from "./DetailBarangKeluar.vue?vue&type=script&lang=js"
export * from "./DetailBarangKeluar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports